import { useState, useEffect } from 'react';
import { useUserContext } from '../../../hooks/useUserContext';
import { useTranslation } from 'react-i18next';
import ImageMap from '../../welten/ImageMap';
import "./Kindeswohl.css";

export default function Lebensstandard({oldAndNewScore}) {
    const { t } = useTranslation();
    //variables for score and state updating
    const { games, updateGames, calculateScore, score } = useUserContext();
    const lebensstandard = games.lebensstandard;
    const max_points = games.lebensstandard.points_max;

    //set up image map variables
    const height = window.innerHeight*0.6;
    const imgSrc = "Lebensstandard.png";
    const imgWidth = (height/1233)*2776;
    const viewbox = "0 0 " + imgWidth.toString() + " " + height.toString();
    const factor = height/1233;
    const imgMap = {
        imgSrc: imgSrc,
        areas: [
          {
            id: 1,
            name: 'lebensstandard1',
            type: 'rect',
            x: 131,
            y: 74,
            width: 281,
            height: 180,
          },
          {
            id: 10,
            name: 'lebensstandard7',
            type: 'rect',
            x: 90,
            y: 430,
            width: 285,
            height: 260,
          },
          {
            id: 2,
            name: 'lebensstandard2',
            type: 'rect',
            x: 32,
            y: 896,
            width: 281,
            height: 240,
          },
          {
            id: 3,
            name: 'lebensstandard3',
            type: 'rect',
            x: 725,
            y: 632,
            width: 168,
            height: 302,
          },
          {
            id: 4,
            name: 'nope',
            type: 'rect',
            x: 905,
            y: 167,
            width: 298,
            height: 220,
          },
          {
            id: 5,
            name: 'nope',
            type: 'rect',
            x: 1239,
            y: 824,
            width: 290,
            height: 196,
          },
          {
            id: 6,
            name: 'lebensstandard4',
            type: 'rect',
            x: 1575,
            y: 48,
            width: 272,
            height: 265,
          },
          {
            id: 7,
            name: 'nope',
            type: 'rect',
            x: 1753,
            y: 565,
            width: 312,
            height: 219,
          },
          {
            id: 8,
            name: 'lebensstandard5',
            type: 'rect',
            x: 2163,
            y: 914,
            width: 160,
            height: 299,
          },
          {
            id: 9,
            name: 'lebensstandard6',
            type: 'rect',
            x: 2459,
            y: 313,
            width: 305,
            height: 299,
          }
        ],
    }

    const [wimmelbilder, setWimmelbilder] = useState({
        lebensstandard1: false,
        lebensstandard2: false,
        lebensstandard3: false,
        lebensstandard4: false,
        lebensstandard5: false,
        lebensstandard6: false,
        lebensstandard7: false
    });

    const [text, setText] = useState(t('lebensstandard.start_text'));

    const clicked = (event, name) => {
        if (name!=="nope") {
            setWimmelbilder(wimmelbilder => ({...wimmelbilder, [name]: true}));
            event.target.id="active";
            show_message("good");
        } else if (name === "nope") {
            event.target.id="wrong";
            show_message("bad");
        };
        
    };

    const [wimmelbild_msg, setWimmelbildMsg] = useState("");
    const show_message = (state) => {
        if (state === "good") {
            setWimmelbildMsg(t('lebensstandard.correct'));
        } else if (state === "bad") {
            setWimmelbildMsg(t('lebensstandard.wrong'));
        };
        document.getElementById("wimmelbild_message").style.display = "flex";
        setTimeout(() => document.getElementById("wimmelbild_message").style.display="none", 1000);
    };

    useEffect(() => {
        let finished_temp = true;
        for (const value of Object.values(wimmelbilder)) {
            if (value === false) {
                finished_temp = false;
            };
        };
        if (finished_temp === true) {
            setText(t('lebensstandard.finish_text'));
            const lebensstandard_new = { ...lebensstandard, state: 'done', points_achieved: max_points };
            const games_new = { ...games, lebensstandard: lebensstandard_new };
            updateGames(games_new);
            const current_game = "lebensstandard";
            let total_score = calculateScore(current_game);
            total_score += max_points;
            const oldScore = score;
            const newScore = total_score;
            oldAndNewScore(oldScore, newScore);
            //updateScore(total_score);
            setTimeout(() => {
                setWimmelbildMsg(t('lebensstandard.finished'));
                document.getElementById("wimmelbild_message").style.display="flex";
                }
                , 1500);
        };
    },[wimmelbilder]);

    return (
        <div className="wimmelbild">
            <h2>{text}</h2>
            <div className="wrapper_wimmelbild" style={{ width: "100%", height: "65vh", overflowX: "auto", overflowY: "auto" }}>
                <ImageMap clicked={clicked} factor={factor} imgWidth={imgWidth} viewbox={viewbox} height={height} imgMap={imgMap} folder="game"/>
            </div>
            <div className="wimmelbild_message" id="wimmelbild_message">
                <p>{wimmelbild_msg}</p>
            </div>
        </div>
    )
}